import React from 'react';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { categoriesSelector } from 'Douleutaras/redux/data/categories/categoriesSlice';
import { businessUnitsSelector } from 'Douleutaras/redux/data/businessUnits/businessUnitsSlice';
import DropdownJobItem from 'Douleutaras/components/Dropdown/DropdownJobItem';

interface DropdownJobItemContainerProps {
  // Href link of the item
  href?: string;
  jobId: string;
  categoryId: string;
  callback(status: boolean): void;
}

const DropdownJobItemContainer: React.FC<DropdownJobItemContainerProps> = props => {
  const {
    jobId,
    categoryId,
    href,
    callback = () => true
  } = props;

  const jobCategory = useAppSelector(state => categoriesSelector.selectById(state, categoryId));
  const businessUnit = useAppSelector(state => businessUnitsSelector.selectById(state, jobCategory?.relationships?.businessUnit.data.id));

  return (
    <DropdownJobItem jobId={jobId}
                     href={href}
                     title={jobCategory.attributes.title}
                     icon={businessUnit.attributes.jobListIllustrationUrl}
                     callback={callback}
    />
  );
};

export default DropdownJobItemContainer;
